module.exports = __webpack_public_path__ + "static/media/Nonord-C-Y-A-trial-kan-du-gjenta.32086040.mp3";